const METRICS_PREFIX = 'onboarding.video.'

export const countAppMetric = (metricName, metricPrefix) => {
  const prefix = metricPrefix || METRICS_PREFIX

  return {
    metric: prefix + metricName,
    value: 1,
    dimensions: {
      type: 'counter',
    },
  }
}
